// extracted by mini-css-extract-plugin
export default {"label":"styled_label__VuBv4","input":"styled_input__x2uVf","error_text":"styled_error_text__1Pm3+"};